import axios from 'axios';
import { baseurl } from '../config/baseurl';

// Configuration de base d'Axios
const API = axios.create({
  // baseURL: 'http://localhost:1000/api/v1', // Remplacez par votre URL de base
  baseURL:"https://yx6wrc8w322m744j-ecom-api.onrender.com/api/v1",
  // timeout: 100000
});

// Intercepteur pour ajouter le token JWT à chaque requête
API.interceptors.request.use(
  (config) => {
    const token = baseurl.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default API;
